(function(document, $){
  "use strict";

  jQuery(document).ready(function($) {

    $('body').on('click', '.trigger-search', function(event){
      event.stopPropagation();
      event.preventDefault();
      $('#cwf-hdr-checkbox-search').prop("checked", true);
    })

    $('#cwf-hdr-search-input').on('keypress', function() {
        $('body').addClass('search-active');
    });

    $('#cwf-hdr-search-clear').on('click', function(){
        $('body').removeClass('search-active');
        $('.cwf-hdr-checkbox-flyout-menu').prop("checked", false);
    });

    $('#filter-toggle').on('click', function(){
        $(this).toggleClass('open');
        $('#ais-facets').slideToggle();
    });
  }) //END OF DOC READY

})(document, window.jQuery);
